/* eslint-disable camelcase */
import React, { Component } from 'react';
import { Popover } from 'antd';
import styles from './generalSituation.less';

class GeneralSituation extends Component {
  render() {
    const { data = [], title = '' } = this.props
    return (
      <div className={styles.generalSituation}>
        <div className='wrap'>
          <div className='title'>{title}</div>
          <div className={`details-wrap length${data.length}`}>
            {
              data.map(item => {
                return <div className={`item-wrap length${data.length}`}>
                  <div className='number'>{item.num}</div>
                  <Popover
                    placement="bottom"
                    trigger="hover"
                    content={item.name || item.areaName}
                  >
                    <div className='name'>{item.name || item.areaName}</div>
                  </Popover>
                </div>
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default GeneralSituation
